<template>
    <v-container fluid>
        <v-card class="d-flex align-content-center justify-space-between mb-6"
                flat>
            <v-card v-if="ScheduleDirect" class="pa-2"
                    flat>
                <h1>Afspraak bevestiging</h1>
                <p>Met onderstaande gegevens is er een afspraak gepland bij uw therapeut. Deze afspraak is bevestigd door de praktijk. Indien onderstaande gegevens niet correct zijn of u wilt de afspraak annuleren, kunt u binnen openingstijden contact opnemen met de praktijk.</p>
            </v-card>
            <v-card v-else class="pa-2"
                    flat>
                <h1>Afspraak verzoek</h1>
                <p>Met onderstaande gegevens is er een afspraak verzoek ingediend bij uw therapeut. Deze afspraak dient nog bevestigd te worden door de praktijk. Indien onderstaande gegevens niet correct zijn of u wilt de afspraak annuleren, kunt u binnen openingstijden contact opnemen met de praktijk.</p>
            </v-card>
            <v-card class="pa-2"
                    flat>
                <v-btn fab
                       medium
                       dark
                       @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card>
        </v-card>

        <p>Voornaam*</p>
        <v-text-field v-model="confirmationModel.clientFirstName"
                      filled
                      readonly>
        </v-text-field>

        <p>Tussenvoegsel</p>
        <v-text-field v-model="confirmationModel.clientPrefixName"
                      filled
                      readonly>
        </v-text-field>

        <p>Achternaam*</p>
        <v-text-field v-model="confirmationModel.clientLastName"
                      filled
                      readonly>
        </v-text-field>

        <p>E-mailadres*</p>
        <v-text-field v-model="confirmationModel.clientEmail"
                      filled
                      readonly>
        </v-text-field>

        <p>Telefoonnummer*</p>
        <v-text-field v-model="confirmationModel.clientPhone"
                      filled
                      readonly>
        </v-text-field>

        <p>Locatie</p>
        <v-text-field v-model="confirmationModel.locatieName"
                      filled
                      readonly>
        </v-text-field>

        <p>Selecteer de gewenste therapeut*</p>

        <v-sheet class="mx-auto" color="blue lighten-5">
            <v-container fluid>
                <p><b> {{confirmationModel.therapeutName}}</b></p>
                <p>{{confirmationModel.therapeutDescription}}</p>
            </v-container>
        </v-sheet>

        <p>Type afspraak* </p>
        <v-text-field v-model="confirmationModel.appointmentName"
                      filled
                      readonly>
        </v-text-field>

        <p>Categorie* </p>
        <v-text-field v-model="confirmationModel.categoryTitle"
                      filled
                      readonly>
        </v-text-field>

        <p>Afspraak</p>
        <v-text-field v-model="confirmationModel.appointmentMoment"
                      filled
                      readonly>
        </v-text-field>

        <p>Geboortedatum* </p>
        <v-text-field v-model="confirmationModel.clientBirthDay"
                      filled
                      readonly>
        </v-text-field>

        <p>Maand* </p>
        <v-text-field v-model="confirmationModel.clientBirthMonth"
                      filled
                      readonly>
        </v-text-field>

        <p>Jaar* </p>
        <v-text-field v-model="confirmationModel.clientBirthYear"
                      filled
                      readonly>
        </v-text-field>

        <p>Postcode* </p>
        <v-text-field v-model="confirmationModel.clientZipCode"
                      filled
                      readonly>
        </v-text-field>

        <p>Huisnummer* </p>
        <v-text-field v-model="confirmationModel.clientHuisnummer"
                      filled
                      readonly>
        </v-text-field>

        <p>Toevoeging </p>
        <v-text-field v-model="confirmationModel.clientHuisnummerToevoeging"
                      filled
                      readonly>
        </v-text-field>
    </v-container>
</template>
<script>
    /* eslint-disable */
    import { mapState } from "vuex";
    import * as moment from "moment";

    export default {
        created() {
            this.fetchData();
            this.confirmationModel.clientBirthMonth = moment().month(this.confirmationModel.clientBirthMonth-1).format('MMMM');
        },
        data: () => ({
            confirmationModel: {},
            ScheduleDirect: false
        }),
        computed: {
            ...mapState("app", ["status", "siteInfo"]),
        },
        mounted: function () {
            this.checkDirectSchedule();
        },
        methods: {
            fetchData() {
                this.confirmationModel = this.$route.params.confirmationModel;
            },
            close() {
                var vm = this;
                vm.$router.push('/');
                location.reload();
            },
            checkDirectSchedule() {
                this.ScheduleDirect = this.siteInfo.scheduleDirect;
            }
        },
    };
</script>
